import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  setLoading, setLoadingSearch,
  setLedgerData, setSearchResults,
} from "./intangibleAssetLedgerSlice";
import { getIntangibleAssetLedgerApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchIntangibleAssetLedger = createAsyncThunk(
  "intangibleAssetLedger/fetchLedger",
  async (payload, { dispatch }) => {
    try {
      dispatch(setLoading(true));

      const response = await getIntangibleAssetLedgerApi({
        accId:    payload.accId,
        dateFrom: payload.fromDate,
        dateTo:   payload.toDate,
      });

      if (response.data) {
        // Optionally enrich with account info
        const accResponse = await getAccountBySeachApi({
          query: "",
          type: "intangible_asset",
          acc_id: payload.accId,
        });

        dispatch(setLedgerData({
          ...response.data,
          ...(accResponse.data?.[0] ? { account: accResponse.data[0] } : {}),
        }));
      }

      return response.data;
    } catch (error) {
      console.error("Error fetching intangible asset ledger:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const searchIntangibleAccounts = createAsyncThunk(
  "intangibleAssetLedger/searchAccounts",
  async (searchTerm, { dispatch }) => {
    try {
      dispatch(setLoadingSearch(true));
      const response = await getAccountBySeachApi({
        query: searchTerm.trim(),
        type: "intangible_asset",
      });
      dispatch(setSearchResults(response.data || []));
      return response.data;
    } catch (error) {
      console.error("Error searching intangible accounts:", error);
      throw error;
    } finally {
      dispatch(setLoadingSearch(false));
    }
  }
);